<template>
  <component :is="iconComponent" :class="['size',className, variant]" />
</template>

<script>
import { NavigationMenuIconsMap } from '@/constants/NavigationMenuIconsList'
import * as NavigationMenuIcons from '@/constants/NavigationMenuIcons'

export default {
  name: 'SecondaryNavigationMenuItemIcon',
  components: {
    ...NavigationMenuIcons
  },
  props: {
    name: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: 'default',
      validator (variant) {
        if (!variant) {
          return true
        }

        return ['default', 'isActive'].includes(variant)
      }
    },
    className: String
  },
  computed: {
    iconComponent () {
      if (!this.name) {
        throw new Error(`"${this.name}" icon is not found`)
      }

      return NavigationMenuIconsMap[this.name]
    }
  }
}
</script>

<style lang="scss" scoped>

.size {
  width: 24px;
  height: 24px;
}

.default {
  color: $fontColor2;
}

.isActive {
  color: $iconColor !important;
}

</style>
